/**
 * Custom Discount Exclusion Script for ANAHATA10
 * Excludes specific product (ID: 10286159495444) from applying the discount.
 */
(function() {
  const RESTRICTED_PRODUCT_ID = 10286159495444;
  const DISCOUNT_CODE = "ANAHATA10";

  // Helper to extract cookie value by name
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  // Main logic to verify cart items and remove the discount if necessary
  async function checkCartAndDiscount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Determine if the restricted product is in the cart
      const hasRestrictedProduct = cart.items.some(item => item.product_id === RESTRICTED_PRODUCT_ID);
      
      if (hasRestrictedProduct) {
        // 1. Check cookies or URL
        const urlParams = new URLSearchParams(window.location.search);
        const discountFromCookieOrUrl = getCookie('discount_code') || urlParams.get('discount');
        const hasDiscountInCookieOrUrl = discountFromCookieOrUrl && discountFromCookieOrUrl.toUpperCase() === DISCOUNT_CODE.toUpperCase();

        // 2. Check cart-level discount applications in the JSON
        const hasDiscountInCart = cart.cart_level_discount_applications && cart.cart_level_discount_applications.some(
          app => app.title && app.title.toUpperCase() === DISCOUNT_CODE.toUpperCase()
        );

        // 3. Check line-item discount allocations in the JSON
        const hasDiscountInItems = cart.items && cart.items.some(item => 
          item.line_level_discount_allocations && item.line_level_discount_allocations.some(
            alloc => alloc.discount_application && alloc.discount_application.title && alloc.discount_application.title.toUpperCase() === DISCOUNT_CODE.toUpperCase()
          )
        );

        const isDiscountApplied = hasDiscountInCookieOrUrl || hasDiscountInCart || hasDiscountInItems;

        if (isDiscountApplied) {
          console.warn(`[Discount Exclusion] Product ${RESTRICTED_PRODUCT_ID} is restricted. Removing discount code ${DISCOUNT_CODE}.`);
          
          // Call Cart API to clear the discount code
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ discount: '' })
          });
          
          // Reload page to update cart pricing totals
          window.location.reload();
        }
      }
    } catch (error) {
      console.error('[Discount Exclusion] Error evaluating cart rules:', error);
    }
  }

  // Intercept native fetch requests to catch AJAX cart additions/updates
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    return originalFetch.apply(this, args).then(response => {
      const url = args[0];
      if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear'))) {
        // Run verification after a short delay to allow cart updates to commit
        setTimeout(checkCartAndDiscount, 500);
      }
      return response;
    });
  };

  // Intercept XMLHttpRequest for themes using older jQuery AJAX
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this.addEventListener('load', function() {
      if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear'))) {
        setTimeout(checkCartAndDiscount, 500);
      }
    });
    return originalOpen.apply(this, arguments);
  };

  // Bind evaluation onto standard page load events
  document.addEventListener('DOMContentLoaded', checkCartAndDiscount);
  window.addEventListener('load', checkCartAndDiscount);
})();
